import { gql } from "@apollo/client";

export const QR_LIST_FAVORITE = gql`
  query GetFavoriteList(
    $paginationParams: BaseCollection!
    $personId: String!
    $serviceType: ServiceTypeInput!
  ) {
    QR_LIST_FAVORITE(
      paginationParams: $paginationParams
      personId: $personId
      serviceType: $serviceType
    ) {
      code
      error {
        message
        timestamp
        correlationId
      }
      data {
        totalElements
        totalPages
        currentPage
        content {
          id
          personId
          entityType
          entityId
        }
      }
    }
  }
`;

export const DELETE_FAVORITE = gql`
  mutation DeleteFavorite($personId: String!, $favoriteId: String!) {
    MT_DELETE_FAVORITE(personId: $personId, favoriteId: $favoriteId) {
      code
      error {
        message
        timestamp
        correlationId
      }
    }
  }
`;

export const ADD_FAVORITE = gql`
  mutation AddFavorite($personId: String!, $favoriteInput: FavoriteInput!) {
    MT_ADD_FAVORITE(personId: $personId, favoriteInput: $favoriteInput) {
      code
      data{
        id
        personId
        entityType
        entityId
      }
      error {
        message
        timestamp
        correlationId
      }
    }
  }
`;
